import React from 'react';

// Utility function to return SVG icons as React elements
export const renderIcon = (slug) => {
  switch (slug) {
    case 'close':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6.00005L6 18M5.99995 6L17.9999 18"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'minus':
      return (
        <svg
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.25 6.5H9.75"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'plus':
      return (
        <svg
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 2.75V10.25"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 6.5H9.75"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'loader':
      return (
        <svg
          className="arrow-loader"
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4058_83)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.55489 4.86292L11.3371 3.83393C10.6468 2.65951 9.54959 1.86982 8.32785 1.5424C7.09459 1.21201 5.7349 1.35198 4.54164 2.04109C3.3482 2.73004 2.5472 3.83735 2.2168 5.07077C2.2022 5.12511 2.1883 5.1796 2.1758 5.23441L1.064 4.87818L0.8663 4.81465C0.8745 4.78165 0.8831 4.74864 0.892 4.71579C1.3133 3.14326 2.3347 1.73141 3.8555 0.853132C5.37679 -0.0249915 7.11 -0.203574 8.68237 0.217894C10.2432 0.636092 11.6449 1.64562 12.5246 3.14809L14 2.29628L13.5955 4.16229L13.191 6.0283L11.3728 5.44553L9.55489 4.86292Z"
              fill="#121211"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 10.5084L0.4045 8.64238L0.8091 6.77637L2.6273 7.35914L4.44571 7.94206L2.753 8.91921C3.4441 10.0779 4.53383 10.8573 5.74546 11.1819C6.97872 11.5125 8.33826 11.3725 9.53151 10.6834C10.6612 10.0313 11.4392 9.00406 11.7994 7.8502L12.679 8.13217L13.1053 8.26871C12.6448 9.73614 11.6543 11.042 10.2173 11.8714C8.6962 12.7498 6.96284 12.9282 5.39031 12.5069C3.8393 12.0913 2.4455 11.0916 1.565 9.60505L0 10.5084Z"
              fill="#121211"
            />
          </g>
          <defs>
            <clipPath id="clip0_4058_83">
              <rect
                width="14"
                height="13"
                fill="white"
                transform="matrix(-1 0 0 1 14 0)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'free-gift':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 14V8"
            stroke="#5C8D48"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.3333 8.00002V12.6667C13.3333 13.4031 12.7364 14 12 14H4C3.26362 14 2.66667 13.4031 2.66667 12.6667V8.00002M14 8.00002V6.00002C14 5.26364 13.403 4.66669 12.6667 4.66669H3.33333C2.59695 4.66669 2 5.26364 2 6.00002V8.00002H14Z"
            stroke="#5C8D48"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 4.66667H10.7C12.6306 4.66667 12.6306 2 10.7 2C8.6 2 8 4.66667 8 4.66667Z"
            stroke="#5C8D48"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.99998 4.66667H5.29998C3.45317 4.66667 3.34012 2 5.29998 2C7.39998 2 7.99998 4.66667 7.99998 4.66667Z"
            stroke="#5C8D48"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'toggle-on':
      return (
        <svg
          width="40"
          height="20"
          viewBox="0 0 40 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="20" rx="10" fill="#121211" />
          <rect x="22" y="2" width="16" height="16" rx="8" fill="#FCFCFC" />
        </svg>
      );
    case 'toggle-off':
      return (
        <svg
          width="40"
          height="20"
          viewBox="0 0 40 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="40"
            y="20"
            width="40"
            height="20"
            rx="10"
            transform="rotate(-180 40 20)"
            fill="#B6B5B2"
          />
          <rect
            x="18"
            y="18"
            width="16"
            height="16"
            rx="8"
            transform="rotate(-180 18 18)"
            fill="#FCFCFC"
          />
        </svg>
      );
    case 'info-circle':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.99999 10.6667V7.33335H7.66666M7.66666 10.6667H8.33332"
            stroke="#121211"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 5.66665V5.33331"
            stroke="#121211"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="8"
            cy="8"
            r="6"
            stroke="#121211"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'info-pointer-up':
      return (
        <svg width="27" height="12" viewBox="0 0 27 12" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.8144 11.9982H0.282288L11.3871 0.893397C12.5807 -0.300241 14.516 -0.30024 15.7096 0.893397L26.8144 11.9982ZM12.1075 1.61382C12.9032 0.818063 14.1934 0.818063 14.9892 1.61382L24.3547 10.9793H13.5483H2.74197L12.1075 1.61382Z"
            fill="#D4D3CF"
          />
          <path
            d="M12.1075 1.61379C12.9032 0.818028 14.1934 0.818028 14.9891 1.61379L25.3945 11.997H1.5401L12.1075 1.61379Z"
            fill="#F8F7F3"
          />
        </svg>
      );
    case 'info-pointer-down':
      return (
        <svg width="27" height="12" viewBox="0 0 27 12" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.282305 0.0017064L26.8144 0.00170872L15.7096 11.1065C14.516 12.3001 12.5807 12.3001 11.3871 11.1065L0.282305 0.0017064ZM14.9892 10.3861C14.1934 11.1818 12.9033 11.1818 12.1075 10.3861L2.74199 1.02054L13.5483 1.02054L24.3547 1.02054L14.9892 10.3861Z"
            fill="#D4D3CF"
          />
          <path
            d="M14.9892 10.386C14.1935 11.1818 12.9033 11.1818 12.1075 10.386L1.70217 0.00277544L25.5566 0.00277753L14.9892 10.386Z"
            fill="#F8F7F3"
          />
        </svg>
      );
    case 'info-close':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4.00003L4 12M3.99997 4L11.9999 12"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'max-limit':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          className="{{ class }}"
        >
          <g clipPath="url(#clip0_4564_1048)">
            <path
              d="M8.90069 3.01375L14.3669 12.5056C14.7501 13.1744 14.2551 14 13.4663 14H2.53381C1.74506 14 1.25006 13.1744 1.63319 12.5056L7.09944 3.01375C7.49319 2.32875 8.50694 2.32875 8.90069 3.01375Z"
              stroke="#A11A20"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 9.5V7"
              stroke="#A11A20"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 12.375C8.34518 12.375 8.625 12.0952 8.625 11.75C8.625 11.4048 8.34518 11.125 8 11.125C7.65482 11.125 7.375 11.4048 7.375 11.75C7.375 12.0952 7.65482 12.375 8 12.375Z"
              fill="#A11A20"
            />
          </g>
          <defs>
            <clipPath id="clip0_4564_1048">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};
